import { useCallback } from "react";

import { authApi, authQueryKeys, getUserInfoQueryOptions, useUserActions } from "@/modules/auth";
import { PrivacyFolderDialog } from "@/modules/mine/components/folder/privacy-folder-dialog";
import type { Folder } from "@/modules/mine/navigation/types";
import { queryClient } from "@/shared/api/query-client";
import { useDialog } from "@/shared/components/dialog";

type Mode = "protect" | "unprotect" | "unlock" | "manage";

export function useFolderPrivacyDialog() {
  const dialog = useDialog();
  const { setToken } = useUserActions();

  return useCallback(async (mode: Mode, folder?: Folder) => {
    const userInfo = await queryClient.fetchQuery(getUserInfoQueryOptions());
    return dialog.open(PrivacyFolderDialog, {
      mode,
      folder,
      hasAccountPassword: Boolean(userInfo?.has_password),
      privacyConfigured: Boolean(userInfo?.privacy_configured),
      onSetAccountPassword: async (password: string) => {
        const reply = await authApi.setNewPassword({ new_password: password });
        setToken(reply.token);
      },
      onPrivacyChanged: () => {
        void queryClient.invalidateQueries({ queryKey: authQueryKeys.userInfo });
      },
    }, {
      title: mode === "unlock" ? "解锁私密文件夹" : mode === "manage" ? "隐私密码" : mode === "protect" ? "设为私密文件夹" : "取消私密保护",
      className: "sm:max-w-md",
    });
  }, [dialog, setToken]);
}
